import { useState } from 'react';

const faqs = [
  {
    q: 'Who provides professional painters near me in Elk Grove Village, Illinois?',
    a: 'Hometown Painters offers interior and exterior painting services throughout Elk Grove Village and the Chicago suburbs, delivering clean finishes, detailed prep work, and professional results for both residential and commercial properties.',
  },
  {
    q: 'How much does professional painting cost in Illinois?',
    a: 'Costs vary based on project size, surface condition, and materials. Most painting projects are quoted after a free consultation to ensure accurate pricing based on scope and desired finish level. Contact us for a no-obligation estimate.',
  },
  {
    q: 'How long does a painting project take?',
    a: 'Most residential projects take a few days to a week depending on size and complexity. Larger or commercial projects may require additional time based on preparation and scheduling needs. We provide clear timelines during the consultation.',
  },
  {
    q: 'Do you offer cabinet painting services in Elk Grove Village?',
    a: 'Yes — cabinet painting is one of our most popular services. We apply factory-style finishes to kitchen and bathroom cabinets, producing results that look like brand new cabinetry at a fraction of the full replacement cost.',
  },
  {
    q: 'Are your painting crews insured and professional?',
    a: 'Absolutely. Hometown Painters operates with fully insured crews trained to maintain clean, organized job sites. We use professional-grade materials and follow a rigorous process to protect your home and deliver consistent, high-quality results.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="bg-warm-cream py-24">
      <div className="max-w-[900px] mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="font-sans text-charcoal-500 text-xs tracking-[0.3em] uppercase">Common Questions</span>
          <h2 className="font-serif text-charcoal-900 text-4xl md:text-5xl mt-3">Frequently Asked</h2>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-xl overflow-hidden border transition-colors duration-200 ${
                open === i ? 'border-gold/40 bg-white' : 'border-charcoal-100 bg-white hover:border-gold/20'
              }`}
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                onClick={() => setOpen(open === i ? null : i)}
                aria-expanded={open === i}
              >
                <span className="font-serif text-charcoal-900 text-base leading-snug pr-4">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center shrink-0 bg-gold/10 rounded-full">
                  <i
                    className={`${open === i ? 'ri-subtract-line' : 'ri-add-line'} text-gold`}
                    style={{ fontSize: '16px' }}
                  />
                </div>
              </button>

              {open === i && (
                <div className="px-6 pb-5">
                  <div className="w-full h-px bg-gold/10 mb-4" />
                  <p className="font-sans text-charcoal-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Schema.org FAQ structured data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((faq) => ({
                '@type': 'Question',
                name: faq.q,
                acceptedAnswer: { '@type': 'Answer', text: faq.a },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}
